<template>
  <!-- 4-3医疗机构认证搜索页面 -->
  <div class="main-css">
    <div class="main-box">
      <!-- 搜索部分 -->
      <div class="search">
        <!-- 搜索框 -->
        <el-input :placeholder="elInputSearch" v-model="inputData1">
          <i slot="suffix" class="el-input__icon el-icon-search"></i>
        </el-input>
        <!-- 搜索按钮 -->
        <button @click="loadPage">{{ $t("search") }}</button>
      </div>
      <!-- table部分 -->
      <div class="table">
        <el-table
          :data="tableData"
          style="width: 95%"
          height="420"
          @sort-change="changeTableSort"
          v-loading="loading"
        >
          <el-table-column type="selection" width="55"> </el-table-column>
          <!-- ----------------------機関番号---------------------- -->
          <el-table-column
            prop="medicalId"
            label="機関番号"
            width="150"
            :show-overflow-tooltip="true"
          >
            <template slot="header">
              <p>{{ $t("medicId") }}</p>
              <el-input
                v-model="searchData1"
                size="mini"
                placeholder="Search"
                @input="fuzzy" clearable
              />
            </template>
            <template slot-scope="scope">
              {{ scope.row.medicalId }}
            </template>
          </el-table-column>
          <!-- ----------------------医療機関名---------------------- -->
          <el-table-column
            prop="medicalName"
            label="医療機関名"
            width="180"
            :show-overflow-tooltip="true"
          >
            <template slot="header">
              <p>{{ $t("medicalInstitution") }}</p>
              <el-input
                v-model="searchData2"
                size="mini"
                placeholder="Search"
                @input="fuzzy" clearable
              />
            </template>
            <template slot-scope="scope">
              {{ scope.row.medicalName }}
            </template>
          </el-table-column>
          <!-- ----------------------所在地---------------------- -->
          <el-table-column prop="address" label="所在地"
                           :show-overflow-tooltip="true">
            <template slot="header">
              <p>{{ $t("location") }}</p>
              <el-input
                v-model="searchData3"
                size="mini"
                placeholder="Search"
                @input="fuzzy" clearable
              />
              </template>
              <template slot-scope="scope">
                {{ scope.row.address }}
              </template>
          </el-table-column>
          <!-- ----------------------代表者---------------------- -->
          <el-table-column prop="legalPerson" label="代表者"
                           :show-overflow-tooltip="true">
            <template slot="header">
              <p>{{ $t("representativeName") }}</p>
              <el-input
                v-model="searchData4"
                size="mini"
                placeholder="Search"
                @input="fuzzy" clearable
              />
            </template>
            <template slot-scope="scope">
              {{ scope.row.legalPerson }}
            </template>
          </el-table-column>
          <!-- ---------------------機関属性--------------------- -->
          <el-table-column  label="機関属性"
                           :show-overflow-tooltip="true">
            <template slot="header" >
              <p>{{ $t("institutionalAttributes") }}</p>
              <el-dropdown @command="handlemedicalAttributes">
                <span class="el-dropdown-link" >
                  {{ medicalAttributesName }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-for="(item,index) in 	medicalAttributes"
                    :key="item.code"
                    :command="item"
                  >{{item.name}}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
            <template slot-scope="scope">
              <span v-if="language === 'CN'">
                {{ scope.row.attributes_dictText }}
              </span>
              <span v-else>
                {{ scope.row.jpattributes_dictText }}
              </span>
            </template>
          </el-table-column>
          <!-- -----------------------ベット数----------------------- -->
          <el-table-column prop="bedNumber" label="ベット数"
                           :show-overflow-tooltip="true">
            <template slot="header">
              <p>{{ $t("numberOfBets") }}</p>
            </template>
            <template slot-scope="scope">
              {{ scope.row.bedNumber }}
            </template>
          </el-table-column>
          <!-- -----------------------求人案件数----------------------- -->
          <el-table-column
            prop="casesNumber"
            label="求人案件数"
            :sortable="'custom'"
            :show-overflow-tooltip="true"
          >
            <template slot="casesNumber">
              <p class="operate">    {{ $t("jobCaseNumber") }}</p>

            </template>
            <template slot-scope="scope">
              {{ scope.row.casesNumber }}
            </template>
          </el-table-column>
          <!-- ------------------------観覧回数------------------------ -->
          <el-table-column
            prop="browseNumber"
            label="観覧回数"
            :sortable="'custom'"
            :show-overflow-tooltip="true"
          >
            <template slot="header">
              <p class="operate">  {{ $t("numberOfVisits") }}</p>
            </template>
            <template slot-scope="scope">
              {{ scope.row.browseNumber }}
            </template>
          </el-table-column>
          <!-- --------------------------操作-------------------------- -->
          <el-table-column
            label="操作"
            width="180"
            align="center"
          >
            <template slot="header">
              <p class="operate">  {{ $t("operate") }}</p>
            </template>
            <template slot-scope="scope">
              <button
                @click="staffApplicationHandleAdd(scope.row)"
                class="staff-application"
              >
                {{ $t("staffApplication") }}
              </button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页部分 -->
      <div class="pagination">
        <div class="pagination-main">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            layout=" prev, pager, next"
            :total="totalItem"
            :page-size="pageSize"
          >
          </el-pagination>
          <!-- Rows per page -->
          <div class="rowsPage">
            <span>Rows per page</span>
            <div class="rowsPage-css">
              <el-dropdown @command="handleCommand">
                <span class="el-dropdown-link">
                  {{pageSize}}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="a">7</el-dropdown-item>
                  <el-dropdown-item command="b">15</el-dropdown-item>
                  <el-dropdown-item command="c">20</el-dropdown-item>
                  <el-dropdown-item command="d">25</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
        </div>
      </div>
      <!-- 员工申请dialog -->
      <div class="employee-application" v-if="dialogIsShow">
        <div class="dialog-box">
          <div class="dialog-img-css">
            <div class="img-box">?</div>
          </div>
          <div class="dialog-title">
            {{ $t("decideIfWantEmployee") }}
          </div>
          <div class="dialog-button">
            <button @click="binDingOrganClick">{{ $t("confirm") }}</button>
          </div>
          <!-- 关闭按钮 -->
          <div class="close-button"  @click="dialogClose">×</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {educationDelete, queryInstitutional, fuzzyQueryInstitutional, getDateItem} from "../../js/api"
import AES from "../../js/AES";
import axios from "axios";
export default {
  name: "medicalInstitution",
  components: {},
  data() {
    return {
      inputData1: "", //搜索框input内容
      tableData: [], //   table内容
      searchDataToLoad: "", //上个页面的传参
      id:"",
      searchData1: "", //表格第一个搜索
      searchData2: "", //表格第二个搜索
      searchData3: "", //表格第三个搜索
      searchData4: "", //表格第四个搜索
      dropdownData1: "", //第一个下拉
      totalItem: "",
      currentPage: 1, //页数
      pageSize: 7, //每页条数
      loading: false, //table loading
      searchDataStart: "",
      dialogIsShow: false, //dialog弹窗标识
      language:"",
      medicalAttributes:[],
      dataItem1:"",
      medicalAttributesName:"All"//机关属性

    };
  },
  created() {
    //获取当前语言的值
    this.language = window.localStorage.getItem('language');
    console.log(this.language,"语言")
    this.getmedicalAttributes();
    this.preloadPage();
  },
  mounted() {
    window.addEventListener('setItemEvent', this.languageChange, true)
  },
  destroyed() {
    window.removeEventListener('setItemEvent', this.languageChange, true)
  },
  computed: {
    elInputSearch() {
      return this.$t("ifRegisteredEnterName");
    }, //搜索部分的placeholder
    institutionNumber() {
      return this.$t("institutionNumber");
    },
  },
  methods: {
    //绑定按钮
    binDingOrganClick() {
      console.log("选择认证机构")
      console.log(this.id)
      const params = new URLSearchParams();
      params.append('organId', this.id);
      axios.post("/api/modules-parent/advancedAuth/binDingOrgan", params, {
        headers: {
          //头部参数
          'Content-Type': 'application/x-www-form-urlencoded',
          'token': localStorage.getItem("token")
        }
      })
        .then(res => {
          if (res.data.code === "A0000") {
            this.dialogClose()
            this.$message({
              message: this.$t('authentication'),
              type: "success"
            });
          } else {
            console.log(localStorage.getItem("token"));
            this.$message.error(res.data.message);
          }
          console.log(res.data);
        })
    },
    //加载页面
    preloadPage(){
      this.inputData1 = this.$route.query.searchData;
      this.loadPage()
    },
    loadPage() {
      console.log(this.inputData1);
      console.log(this.pageSize);
      console.log(this.pageNumber);
      const fakeInfo = {
        "organName": this.inputData1,
        "pageNumber": this.currentPage,
        "pageSize": this.pageSize
      };
      queryInstitutional(fakeInfo)
        .then(res => {
          console.log("-----机构查询-----");
          console.log(res);
          if (res.data.code === "A0000") {
            // this.$message({
            //   // message: "查询成功",
            //   type: "success"
            // });
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data))
            console.log(aesFecInfo)

            this.totalItem = aesFecInfo.total
            this.tableData = aesFecInfo.data
          } else {
            this.$message.error(this.$t('institutionDoesExistEmpty'));
          }
        })
        .catch(res => {
          console.log("-----查询失败-----");
          console.log(res);
        });
    },
    //table排序
    changeTableSort(column) {
      console.log(column);
      if (column.prop === "numberCases") {
        if (column.order === "ascending") {
          this.tableData = this.tableData.sort(
            (a, b) => a["numberCases"] - b["numberCases"]
          );
        } else {
          this.tableData = this.tableData.sort(
            (a, b) => b["numberCases"] - a["numberCases"]
          );
        }
      } else {
        if (column.order === "ascending") {
          this.tableData = this.tableData.sort(
            (a, b) => a["numberViewings"] - b["numberViewings"]
          );
        } else {
          this.tableData = this.tableData.sort(
            (a, b) => b["numberViewings"] - a["numberViewings"]
          );
        }
      }
    },
    //分页
    handleCurrentChange(evt) {
      this.currentPage=evt
      this.fuzzy()
    },
    //每页条数下拉框
    handleCommand(command) {
      if (command === "a") {
        this.pageSize = 7;
      } else if (command === "b") {
        this.pageSize = 15;
      } else if (command === "c") {
        this.pageSize = 20;
      } else if (command === "d") {
        this.pageSize = 25;
      }
      this.currentPage = 1;
      this.fuzzy();
    },
    // 员工申请
    staffApplicationHandleAdd(row) {
      this.dialogIsShow = true;
    },
    //管理员申请
    managerApplicationHandleAdd(row) {
      this.$router.push({
        path: "/advancedCertification",
        query: { rowData: row, role: 1 },
      });
    },
    //dialog关闭
    dialogClose() {
      this.dialogIsShow = false;
    },
    //监听语言
    languageChange(e) {
      const that = this;
      console.log("------监听数据------")
      console.log(e)
      if (e.key && e.key == "language" && e.newValue) {
        that.language = e.newValue
        that.getmedicalAttributes();
        that.preloadPage();
      }
    },
    //机构下拉获取
    getmedicalAttributes(){
      this.getLanguage();
      const fakeInfo = {
        dataItem: this.dataItem1
      };
      getDateItem(fakeInfo)
        .then(res => {
          console.log("-----下拉-----");
          console.log(res);
          if (res.data.code === "A0000") {
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            console.log(aesFecInfo);
            this.medicalAttributes = aesFecInfo.data;
          }
        })
        .catch(res => {
          console.log("-----变更状态数据字典获取-----");
          console.log(res);
        });
    },
    //语言获取
    getLanguage(){
      if (this.language === "CN") {
        this.dataItem1 = "medicalAttributes"
      }
      else {
        this.dataItem1 = "jpmedicalAttributes"
      }
    },
    //获取handlemedicalAttributes下拉
    handlemedicalAttributes(e){
      console.log(e);
      this.dropdownData1=e.code;
      if(e==null){
        this.medicalAttributesName="All";
        console.log(e);
      }else{
        this.medicalAttributesName=e.name;
      }
      this.fuzzy();
    },
    //机构模糊查询
    fuzzy(){

      const fakeInfo = {
        "address": this.searchData3,
        "attributes": this.dropdownData1,
        "institutionId": this.searchData1,
        "institutionName": this.searchData2,
        "legalPerson": this.searchData4,
        "pageNumber": this.currentPage,
        "pageSize": this.pageSize
      };
      console.log(fakeInfo)
      fuzzyQueryInstitutional(fakeInfo)
        .then(res => {
          console.log("-----机构查询-----");
          console.log(res);
          if (res.data.code === "A0000") {
            // this.$message({
            //   message: "查询成功",
            //   type: "success"
            // });
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data))
            console.log(aesFecInfo)

            this.totalItem = aesFecInfo.total
            this.tableData = aesFecInfo.data
          } else {
            this.$message.error("机构不存在或查询输入为空");
          }
        })
        .catch(res => {
          console.log("-----查询失败-----");
          console.log(res);
        });
    }
  },
};
</script>
<style scoped>
.main-css {
  width: 100%;
  height: 100%;
  background: #fff;
}
.main-box {
  margin-top: 86px;
  width: 100%;
  height: 80%;
  padding: 0 40px 0 80px;
  box-sizing: border-box;
  background: #fff;
}
.search {
  width: 100%;
  height: 25px;
  display: flex;
}
.search /deep/ .el-input__inner {
  width: 314px;
  height: 24px;
}
.search /deep/ .el-input {
  width: 314px;
  height: 24px;
  line-height: 24px;
  box-sizing: border-box;
}
.search /deep/ .el-input__icon {
  line-height: 24px;
}
.search button {
  width: 85px;
  height: 24px;
  line-height: 24px;
  background: #fafafa;
  border: 1px solid #51abff;
  box-sizing: border-box;
  border-radius: 8px;
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  color: #51abff;
  cursor: pointer;
  margin-left: 20px;
}
.table {
  margin-top: 20px;
  height: 420px;
}
.table /deep/ .el-input__inner {
  border: 1px solid transparent;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #c9cfda;
  padding: 0;
}
.operate {
  height: 48px;
}
.table /deep/ .el-dropdown {
  width: 100px;
}
.el-dropdown-link {
  cursor: pointer;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #00072b;
  width: 100%;
  display: inline-block;
}
.table /deep/ .el-icon-arrow-down {
  float: right;
  height: 20px;
  line-height: 20px;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.table /deep/ .el-table__cell {
  position: relative;
}
.table /deep/ .caret-wrapper {
  display: inline-block;
  position: absolute;
  top: -5px;
  right: 0;
  width: 67px;
}
.staff-application {
  width: 94px;
  height: 24px;
  background: #fafafa;
  border: 1px solid #51abff;
  box-sizing: border-box;
  border-radius: 8px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0.25px;
  color: #51abff;
  cursor: pointer;
  margin-right: 10px;
}
.manager-application {
  width: 94px;
  height: 24px;
  background: #fafafa;
  border: 1px solid #fc630c;
  box-sizing: border-box;
  border-radius: 8px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0.25px;
  color: #fc630c;
  cursor: pointer;
}
.pagination {
  width: 100%;
  height: 50px;
  margin-top: 10px;
  margin-bottom: 80px;
}

.pagination-main {
  float: right;
  margin-right: 100px;
  display: flex;
}
.rowsPage {
  height: 30px;
  line-height: 30px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  letter-spacing: 0.25px;
  color: #454d59;
  display: flex;
  margin-left: 10px;
}
.rowsPage-css {
  background: peru;
  width: 60px;
  height: 26px;
  line-height: 26px;
  background: #ffffff;
  border: 1px solid #b0bac9;
  box-sizing: border-box;
  padding: 0 5px 0 10px;
  margin-left: 12px;
}
.rowsPage /deep/ .el-dropdown-link {
  width: 45px;
  height: 26px;
  line-height: 26px;
}
.rowsPage /deep/ .el-icon-arrow-down {
  float: right;
  line-height: 26px;
}
.employee-application {
  background: rgba(0, 0, 0, 0.2);
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9;
  display: flex;
  justify-content: center;
  align-items: center;
}
.dialog-box {
  width: 500px;
  height: 270px;
  padding: 20px 0;
  box-sizing: border-box;
  background: #fff;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  position: relative;
}
.close-button {
  width: 50px;
  text-align: center;
  line-height: 50px;
  height: 50px;
  position: absolute;
  top: 0;
  right: 0;
  font-weight: 700;
  font-size: 20px;
  color: #686868;
  cursor: pointer;
}
.dialog-img-css {
  height: 100px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.img-box {
  width: 66px;
  height: 66px;
  background: #fc630c;
  border-radius: 50%;
  text-align: center;
  line-height: 66px;
  font-size: 26px;
  font-weight: 500;
  color: #fff;
}
.dialog-title {
  height: 50px;
  line-height: 50px;
  text-align: center;
  width: 100%;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #686868;
}
.dialog-button {
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.dialog-button button {
  width: 118px;
  height: 24px;
  line-height: 24px;
  background: #ffffff;
  border: 1px solid #fc630c;
  box-sizing: border-box;
  border-radius: 4px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  cursor: pointer;
  color: #fc630c;
}
</style>



// WEBPACK FOOTER //
// src/pages/medicalInstitution/index.vue